// Enums baseados no DTO fornecido
import { i18n } from '../../../translate/i18n'

export enum RoomStatus {
  AVAILABLE = 'available',
  RESERVED = 'reserved',
  MAINTENANCE = 'maintenance',
  OCCUPIED = 'occupied',
  BEING_CLEANING = 'being_cleaning'
}

export enum RoomType {
  SINGLE = 'single',
  DOUBLE = 'double',
  TWIN = 'twin',
  QUEEN = 'queen',
  KING = 'king',
  SUITE = 'suite',
  JUNIOR_SUITE = 'junior_suite',
  MASTER_SUITE = 'master_suite',
  PRESIDENTIAL = 'presidential',
  FAMILY = 'family',
  ACCESSIBLE = 'accessible',
}

export type HotelRoomType = {
  id: number
  roomNumber: string
  status: RoomStatus
  capacity?: number
  price?: number
  type?: RoomType
  pluginspaceId: number
}

export type CreateHotelRoomDto = {
  roomNumber: string
  status?: RoomStatus
  capacity?: number
  price?: number
  type?: RoomType
}

// Funções utilitárias para labels usando i18n
export const getStatusLabel = (status: RoomStatus): string => {
  return i18n.t(`hotelRoom.status.${status}`)
} 

export const getTypeLabel = (type: RoomType): string => {
  return i18n.t(`hotelRoom.type.${type}`)
}

export const getStatusColor = (status: RoomStatus): string => {
  const colors = {
    [RoomStatus.AVAILABLE]: 'success',
    [RoomStatus.RESERVED]: 'warning',
    [RoomStatus.MAINTENANCE]: 'danger',
    [RoomStatus.OCCUPIED]: 'primary',
    [RoomStatus.BEING_CLEANING]: 'dark',
  }
  return colors[status] || 'secondary'
}
